// extracted by mini-css-extract-plugin
export default {"bg":"gallary_bg__IY7TC","header":"gallary_header__34RjF","clientContent":"gallary_clientContent__BxVjE"};